import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { BONOS } from '../data/landing';
export function BonusSection() {
  return <section className="w-full bg-neutral-100 py-10 sm:py-16" data-id="element-19" data-mp="22fmwoxz0u82n">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-20" data-mp="22f3gblp0rrqq">
        <div className="mx-auto max-w-2xl text-center" data-id="element-21" data-mp="1ydi7qcjipzmc">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-green-600 px-3 py-1 text-xs font-black uppercase text-white" data-id="element-22" data-mp="1ybxagf5tk2ks">
            <GiftIcon className="h-3.5 w-3.5" data-id="element-23" data-mp="15pw2z0yk0oxw" /> Regalos exclusivos
          </span>
          <h2 className="mt-4 text-2xl font-black leading-tight text-neutral-900 sm:text-3xl lg:text-4xl" data-id="element-24" data-mp="1jgr4ttamy5rz">
            Si comprás HOY, te llevás gratis estos 5 complementos
          </h2>
          <p className="mt-3 text-base text-neutral-600 sm:text-lg" data-id="element-25" data-mp="1eo7owpoh6yk0">
            Valor real:{' '}
            <span className="font-bold text-neutral-900 line-through" data-id="element-26" data-mp="qy3pkuiblkyt">$81.500</span> —
            hoy incluidos <span className="font-bold text-green-600" data-id="element-27" data-mp="mx1w6ub3434r">sin costo</span>.
          </p>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-28" data-mp="29q8pcmffr1hn">
          {BONOS.map((bono, i) => <motion.div key={bono.numero} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="flex flex-col overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-sm" data-id="element-29" data-mp="2eotik1w9skwl" data-mpi={i}>
              <div className="relative bg-neutral-950 p-2 sm:p-3" data-id="element-30" data-mp="1vueh85mhkg5l">
                <img src={bono.imagen} alt={`${bono.numero}: ${bono.titulo}`} className="mx-auto h-80 w-auto max-w-full object-contain drop-shadow-xl sm:h-96" data-id="element-31" data-mp="20qloc1qmbxp4" />
                <span className="absolute right-3 top-3 rounded-full bg-yellow-400 px-2.5 py-1 text-xs font-black text-neutral-900" data-id="element-32" data-mp="3c6tu0c1cjp50">
                  GRATIS
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5" data-id="element-33" data-mp="1h35avx7rwtxu">
                <span className="text-xs font-black uppercase tracking-wide text-green-600" data-id="element-34" data-mp="1h1kfk5dmx6yx">
                  {bono.numero}
                </span>
                <h3 className="mt-1 text-lg font-bold leading-snug text-neutral-900" data-id="element-35" data-mp="1q4llo62i2y2l">
                  {bono.titulo}
                </h3>
                <p className="mt-2 flex-1 text-sm text-neutral-600" data-id="element-36" data-mp="1m300zyjq5fhu">
                  {bono.descripcion}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-neutral-100 pt-3" data-id="element-37" data-mp="yat5t2pqjek0">
                  <span className="flex items-center gap-1.5 text-sm font-semibold text-green-600" data-id="element-38" data-mp="tbzungxx7zn0">
                    <CheckIcon className="h-4 w-4" data-id="element-39" data-mp="177260jljeh77" /> Incluido hoy
                  </span>
                  <span className="text-sm text-neutral-400 line-through" data-id="element-40" data-mp="12co92cr8820f">
                    {bono.valor}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}